module.exports = __webpack_public_path__ + "img/onlinecare_jumbotron.be1629ae.png";